// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","new":"new_DLui0","overlayImage":"overlayImage_YWwst","depositImage":"depositImage_AVYzH"};